export const isLocalHost = window.location.origin.includes('localhost');
